import type { CampaignStatus } from '~/types/graphql';

import { IDisableStateByStatus } from '../types/campaign-disable-state';
import { CAMPAIGN_STATUS } from '~/constants/campaign';

export const DISABLE_STATE_BY_STATUS: Record<IDisableStateByStatus, CampaignStatus[]> = {
  [IDisableStateByStatus.ACTION_END]: [
    CAMPAIGN_STATUS.COMPLETED,
    CAMPAIGN_STATUS.DRAFT,
    CAMPAIGN_STATUS.STOPPED,
  ],
};
